import type { TableCellProps } from '@chakra-ui/react'
import { Td, Text, Tr } from '@chakra-ui/react'
import React from 'react'

interface EmptyTablePlaceholderProps extends TableCellProps {
  text?: string
  colSpan?: number
  children?: React.ReactNode
}

export const EmptyTablePlaceholder = ({
  text = '',
  colSpan,
  children,
  ...rest
}: EmptyTablePlaceholderProps) => {
  const anyChildren = React.Children.count(children)
  return anyChildren ? (
    children
  ) : (
    <Tr>
      <Td colSpan={colSpan} py={8} textAlign={'center'} borderBottom="none" {...rest}>
        <Text>{text}</Text>
      </Td>
    </Tr>
  )
}
